import React, { FC } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { Background, RecommendationDetailsCont, Title } from './RecommendationList.styles';
import RecommendationCategoryDetails from '../../../../components/RecommendationCategoryDetails/RecommendationCategoryDetails';
import { ERecommendationsLevel, ERecommendationVariant } from '../../../../constans/report';
import { IGetRecommendationsRequest } from '../../../../services/reports';

interface IRecommendationList {
  recommendations: IGetRecommendationsRequest;
}

const RecommendationList: FC<IRecommendationList> = ({ recommendations }) => {
  const { t } = useTranslation();

  return (
    <RecommendationDetailsCont id="RecommendationDetailsCont">
      {!_.isEmpty(recommendations[ERecommendationsLevel.HIGH]) && (
        <>
          <Title id="Title-first">{t('report.recommendation.youShouldImprove')}</Title>
          <Background id="Background">
            {recommendations[ERecommendationsLevel.HIGH]?.map((recommendation, index) => (
              <RecommendationCategoryDetails
                key={index}
                variant={ERecommendationVariant.SHOULD}
                recommendation={recommendation}
              />
            ))}
          </Background>
        </>
      )}
      {!_.isEmpty(recommendations[ERecommendationsLevel.MEDIUM]) && (
        <>
          <Title id="Title-first">{t('report.recommendation.youCouldImprove')}</Title>
          <Background id="Background">
            {recommendations[ERecommendationsLevel.MEDIUM]?.map((recommendation, index) => (
              <RecommendationCategoryDetails
                key={index}
                variant={ERecommendationVariant.COULD}
                recommendation={recommendation}
              />
            ))}
          </Background>
        </>
      )}
      {!_.isEmpty(recommendations[ERecommendationsLevel.LOW]) && (
        <>
          <Title id="Title-first">{t('report.recommendation.youExcelAt')}</Title>
          <Background id="Background">
            {recommendations[ERecommendationsLevel.LOW]?.map((recommendation, index) => (
              <RecommendationCategoryDetails
                key={index}
                variant={ERecommendationVariant.EXCEL}
                recommendation={recommendation}
              />
            ))}
          </Background>
        </>
      )}
    </RecommendationDetailsCont>
  );
};

export default RecommendationList;
